// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".announcement-bar-setting").forEach(function (bar) {
//     const id = bar.dataset.announcementId;
//     if (localStorage.getItem(`${id}-closed`) === "true") {
//       bar.classList.add("display-none");
//     } else {
//       bar.classList.remove("display-none");
//     }

//     const closeBtn = bar.querySelector(".announcement-bar__close");
//     if (closeBtn) {
//       closeBtn.addEventListener("click", function () {
//          bar.classList.add("display-none");
//         localStorage.setItem(`${id}-closed`, "true");
//       });
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".announcement-bar-setting").forEach(function (bar) {
    const id = bar.dataset.announcementId;
    const key = `${id}-closed`;

    if (sessionStorage.getItem(key) === "true") {
      bar.classList.add("display-none");
    } else {
      bar.classList.remove("display-none");
    }

    const closeBtn = bar.querySelector(".announcement-bar__close");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        bar.classList.add("display-none");
        sessionStorage.setItem(key, "true");
      });
    }
  });
});
